
// 导入
import { saveAs as FileSaver } from 'file-saver'
// 使用
function download(URL,fileName){
	const oReq = new XMLHttpRequest()
	oReq.open('GET', URL, true)// URL 为下载的URL地址
	oReq.responseType = 'blob'
	oReq.onload = function() {
	  const file = new Blob([oReq.response], {
	    type: 'blob'
	  })
	  FileSaver.saveAs(file, fileName) // fileName为文件名
	}
	oReq.send()
}
 
export default download


//////////////////
// WEBPACK FOOTER
// ./static/js/download.js
// module id = null
// module chunks = 